import axios from 'axios';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { AddNewVisitRes, AddVisitPayload } from './Model';
import { setupInterceptorsTo } from '../authenticationInterceptors/Interceptors';

type InitialState = {
  loading: boolean;
  response: AddNewVisitRes;
  successMsg: string;
  error: string;
};
const initialState: InitialState = {
  loading: false,
  response: {} as AddNewVisitRes,
  successMsg: '',
  error: '',
};

const baseUrl = 'https://erp-ssssh.technicise.eu';
const accessToken = '3703265d357a211:5b86c8948ff269d';

export const addNewVisit = createAsyncThunk<AddNewVisitRes, AddVisitPayload>(
  'addNewVisit/addNewVisit',
  (payload, { rejectWithValue }) => {
    const headers = {
      Accept: 'application/json',
      'Content-type': 'application/json',
      Authorization: `Token ${accessToken}`,
    };
    return setupInterceptorsTo(axios)
      .post(baseUrl + '/api/resource/Token',
        payload.body,
        { headers })
      .then((response) => response.data)
      .catch((error) =>
        rejectWithValue(
          error?.response?.data !== undefined
            ? error?.response?.data[0]?.description !== undefined
              ? error?.response?.data[0]?.description
              : error.response.data.message !== undefined
                ? error.response.data.message
                : 'Something Went Wrong.'
            : 'Something Went Wrong.',
        ),
      )
  }
);

const addNewVisitSlice = createSlice({
  name: 'addNewVisit',
  initialState,
  reducers: {
    resetAddVisitState: (state) => {
      state.response = {} as AddNewVisitRes;
      state.error = '';
      state.loading = false;
    },
    updateAddNewVisitClearMsg: (state) => {
      state.successMsg = '';
      state.error = '';
    },
    updateAddNewVisitClearRes: (state) => {
      state.successMsg = '';
      state.error = '';
      state.response = {} as AddNewVisitRes;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addNewVisit.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      addNewVisit.fulfilled,
      (state, action: PayloadAction<AddNewVisitRes>) => {
        state.loading = false;
        state.response = action.payload;
      }
    );
    builder.addCase(addNewVisit.rejected, (state, action) => {
      state.loading = false;
      state.response = {} as AddNewVisitRes;
      state.successMsg = '';
      state.error = String(action.payload!);
    });
  },
});
export const { updateAddNewVisitClearMsg, updateAddNewVisitClearRes, resetAddVisitState } = addNewVisitSlice.actions;
export default addNewVisitSlice.reducer;